export const SET_LOADING = "SetLoading";
export const SAVE_ADDRESS = "SaveAddress";
export const SAVE_SECURIT_NUMBER = "SaveSecurityNumber"
